"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

export function TripTabs({ tripId }: { tripId: string }) {
  const pathname = usePathname();
  const base = `/trips/${tripId}`;
  const tabs = [
    { href: base, label: "일정" },
    { href: `${base}/checklist`, label: "준비물" },
    { href: `${base}/budget`, label: "비용" },
    { href: `${base}/map`, label: "지도" },
    { href: `${base}/journal`, label: "기록" },
    { href: `${base}/settings`, label: "설정" },
  ];

  return (
    <nav className="flex gap-1.5 border-b border-border/70 pb-2 print:hidden overflow-x-auto no-scrollbar">
      {tabs.map((tab) => {
        const active = pathname === tab.href;
        return (
          <Link
            key={tab.href}
            href={tab.href}
            className={cn(
              "px-3.5 py-1.5 text-sm font-medium rounded-full transition-all duration-150 shrink-0",
              active
                ? "bg-primary text-primary-foreground shadow-xs font-semibold"
                : "text-muted-foreground hover:text-foreground hover:bg-muted/70"
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
